"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const react_1 = __importStar(require("react"));
const react_tooltip_1 = __importDefault(require("react-tooltip"));
const colors_1 = require("../../../theme/colors");
const icons_1 = require("../../../theme/icons");
const forms_1 = require("../../forms");
const global_1 = require("../../global");
const Header_styles_1 = require("./Header.styles");
const Header = ({ title, children, errorText, primaryButton, secondaryButton, guestSettingsButton, description, calculatingText, }) => {
    const [hide, setHide] = (0, react_1.useState)(window.matchMedia("(max-width: 1199px)").matches);
    (0, react_1.useEffect)(() => {
        const media = window.matchMedia("(max-width: 1199px)");
        const listener = () => setHide(media.matches);
        media.addEventListener("change", listener);
        return () => media.removeEventListener("change", listener);
    });
    return (react_1.default.createElement(Header_styles_1.HeaderWrapper, null,
        react_1.default.createElement(Header_styles_1.Label, null,
            title,
            description && (react_1.default.createElement(Header_styles_1.MessageWrapper, { "data-tip": description, "data-for": "headerTooltip", "data-delay-hide": 2000, "data-effect": "solid" },
                react_1.default.createElement(global_1.IconWrapper, null,
                    react_1.default.createElement(icons_1.Info, null)),
                react_1.default.createElement(react_tooltip_1.default, { id: "headerTooltip", multiline: true, html: true, clickable: true, place: "bottom" })))),
        children,
        react_1.default.createElement(Header_styles_1.ActionContainer, null,
            errorText && (react_1.default.createElement(Header_styles_1.MessageContainer, null,
                react_1.default.createElement(Header_styles_1.IconContainer, { "data-tip": errorText, "data-for": "errorTooltip" },
                    react_1.default.createElement(icons_1.Error, null)),
                react_1.default.createElement(Header_styles_1.Message, { "$color": colors_1.RED }, errorText),
                react_1.default.createElement(react_tooltip_1.default, { id: "errorTooltip", multiline: true, globalEventOff: "click", html: true, clickable: true }))),
            !errorText && calculatingText && (react_1.default.createElement(Header_styles_1.MessageContainer, null,
                react_1.default.createElement(Header_styles_1.IconContainer, null,
                    react_1.default.createElement(forms_1.Loader, null)),
                react_1.default.createElement(Header_styles_1.Message, { "$color": colors_1.DARK_GREEN }, calculatingText))),
            react_1.default.createElement(Header_styles_1.ButtonGroupWrapper, null, !hide && (react_1.default.createElement(react_1.default.Fragment, null,
                guestSettingsButton,
                secondaryButton,
                primaryButton))))));
};
exports.Header = Header;
//# sourceMappingURL=Header.js.map